import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('../MainApp.vue'),
        children: [
            {
                path: '',
                name: 'Home',
                component: () => import('../component/pages/HomePage.vue'),
                meta: { navItem: 'home', headerTransparent: true }
            },
            {
                path: '/gallery',
                name: 'Gallery',
                component: () => import('../component/pages/gallery/GalleryPage.vue'),
                meta: { navItem: 'gallery' }
            },
            {
                path: '/gallery/:id',
                name: 'PaintingDetail',
                component: () => import('../component/pages/gallery/PaintingDetailPage.vue'),
                meta: { navItem: 'gallery' }
            },
            {
                path: '/about',
                name: 'About',
                component: () => import('../component/pages/about/AboutPage.vue'),
                meta: { navItem: 'about' }
            },
            {
                path: '/exhibitions',
                name: 'Exhibitions',
                component: () => import('../component/pages/exhibitions/ExhibitionsPage.vue'),
                meta: { navItem: 'exhibitions' }
            },
            {
                path: '/teaching',
                name: 'Teaching',
                component: () => import('../component/pages/teaching/TeachingPage.vue'),
                meta: { navItem: 'teaching' }
            },
            {
                path: '/contacts',
                name: 'Contacts',
                component: () => import('../component/pages/ContactsPage.vue'),
                meta: { navItem: 'contacts' }
            },
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
    const transparent = to.meta.headerTransparent || false
    store.commit('ui/SET_HEADER_TRANSPARENT', transparent)
    store.commit('ui/SET_ACTIVE_NAV', to.meta.navItem || null)
    store.commit('ui/SET_MOBILE_MENU', false)
    next()
})

export default router
